import { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  getRegionInfo,
  Regions,
  RegionsCode,
  WorldwideCode,
} from '../../../constants/region';
import { TranslationLocale } from '../../../i18n';
import { Regions as TranslatedRegions } from '../../../models/SystemStore/SystemStore';
import { useSessionStore } from '../../../stores/SessionStore';
import { getRegionsList } from '../../../stores/SystemStore';
import { getUiLocale } from '../../../utils/i18n';
import { JoyajoyImage } from '../JoyajoyImage';

import styles from './ChangeCountry.module.css';

export const ChangeCountry = memo(() => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const activeRegion = useSessionStore((store) => store.activeRegion);

  const [translatedRegions, setTranslatedRegions] = useState<TranslatedRegions>(
    {},
  );

  useEffect(() => {
    const fetchTranslatedRegions = async () => {
      // try {
      //   const response = await getRegions({
      //     locale: getUiLocale(i18n.language as TranslationLocale),
      //   });
      //   if (response.ok && response.data) {
      //     // remove the "Worldwide" option
      //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
      //     const { worldwide, ...rest } = response.data.regions;
      //     setTranslatedRegions(rest);
      //   }
      // } catch (error) {
      //   console.error('Error fetching translated regions:', error);
      // }
      try {
        const regions = await getRegionsList(
          getUiLocale(i18n.language as TranslationLocale),
        );
        setTranslatedRegions(regions);
      } catch (error) {
        console.error('Failed to fetch regions:', error);
      }
    };

    void fetchTranslatedRegions();
  }, [i18n.language]);

  const getRegionImage = (regionId: RegionsCode | typeof WorldwideCode) => {
    if (regionId === WorldwideCode) {
      return Regions.find((r) => r.id === WorldwideCode)?.image || '';
    }
    return getRegionInfo(regionId).image || '';
  };

  const onClick = useCallback(() => {
    useSessionStore
      .getState()
      .setScrollPos(window.scrollY || window.pageYOffset);
    if (window.location.href.includes('wea-member')) {
      navigate('/wea-member/account/region');
    } else {
      navigate('/settings/account/region');
    }
  }, [navigate]);

  const getServiceHotline = (code: RegionsCode): string => {
    switch (code) {
      case RegionsCode.HK:
        return '+852 28068380';
      case RegionsCode.CN:
        return '+86 15814710539';
      case RegionsCode.MO:
        return '+853 63502967';
      default:
        return '+852 28068380';
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.changeCountry} onClick={onClick}>
        {t('Change Country / Region: ')}
        <JoyajoyImage
          resource={{ uri: getRegionImage(activeRegion || WorldwideCode) }}
          style={{ width: 28, height: 28, marginRight: 3 }}
        />
        {translatedRegions[activeRegion || WorldwideCode]}
      </div>
      <div className={styles.serviceHotline}>
        {t('Service Hotline: ')}
        <a
          href={`tel:${getServiceHotline(activeRegion)}`}
          className={styles.callLink}
        >
          {getServiceHotline(activeRegion)}
        </a>
      </div>
    </div>
  );
});
